import React from "react";
import { Button } from "antd";
import type { StoreApprovalStatus } from "../types";

export type StoreApprovalTabsProps = {
  active: StoreApprovalStatus;
  pendingCount: number;
  approvedCount: number;
  onChange: (status: StoreApprovalStatus) => void;
};

export const StoreApprovalTabs: React.FC<StoreApprovalTabsProps> = ({
  active,
  pendingCount,
  approvedCount,
  onChange,
}) => {
  return (
    <div className="store-approval-tabs">
      <Button
        type={active === "awaiting_approval" ? "primary" : "default"}
        className={`store-approval-tab ${
          active === "awaiting_approval" ? "store-approval-tab--active" : ""
        }`}
        onClick={() => onChange("awaiting_approval")}
      >
        Waiting For Approval Store
        <span className="store-approval-tab-count">({pendingCount})</span>
      </Button>

      <Button
        type={active === "approved" ? "primary" : "default"}
        className={`store-approval-tab ${
          active === "approved" ? "store-approval-tab--active" : ""
        }`}
        onClick={() => onChange("approved")}
      >
        Approved Store <span className="store-approval-tab-count">({approvedCount})</span>
      </Button>
    </div>
  );
};

export default StoreApprovalTabs;
